'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import type { Locale } from '@/app/lib/i18n'

// Stamps `locale` onto every PostHog event fired from this page (via
// register, which persists the property for the rest of the session) so
// per-locale conversion is measurable once non-English locales ship.
export default function LocaleAnalytics({ locale }: { locale: Locale }) {
  useEffect(() => {
    posthog.register({ locale })
  }, [locale])

  return null
}
